import moment from "moment";
import { toast } from "react-toastify";
import { sendBookMessage } from "../../utils/sendNotification";
import { deleteData, getData, getDataSimple, patchData, postData, postDataSimple, putData, } from "../../utils/serverHelper"
import { ACTIVITY, APPOINTMENT, APPOINTMENTS, BILLING, BUSINESS, BUSINESS_EDIT, BUSINESS_FIELDS, BUSINESS_FIELD_ID, BUSINESS_ID, BUSINESS_LOGO, BUSINESS_PROFILE, BUSINESS_STAFF_ID, CANCEL_APPOINTMENT, COMPLETE_APPOINTMENT, UPDATE_APPOINTMENT_STATUS, COMPLETE_PROFILE, GOOGLE_CALENDAR_CONNECT, PATIENTS, PATIENT_ID, CUSTOMERS, CUSTOMER_ID, DASHBOARD, DELETE_APPOINTMENT, DELETE_SERVICE, REGISTER, RESCHEDULE_APPOINTMENT, SERVICES, STAFF, STAFF_ID, TIMINGS, UPLOAD_DATA, PRODUCTS, PRODUCT_ID, } from "../../utils/urls"
import {  errorActivity, failedBookAppointment, failedBusiness,  failedBusinessAppointments,  failedBusinessCustomers,  failedBusinessDetails,  failedBusinessDocuments,  failedBusinessFields,  failedBusinessRestrict,  failedBusinessService,  failedBusinessStaff,  failedBusinessTimings,  failedCustomerAdd,  failedDashboard,  failedStaffDetailsWeb,  loadingActivity,  loadingBookAppointment,  loadingBusiness,  loadingBusinessAppointments,  loadingBusinessCustomers,  loadingBusinessDetails,  loadingBusinessDocuments,  loadingBusinessFields,  loadingBusinessRestrict,  loadingBusinessServices,  loadingBusinessStaff,  loadingBusinessTimings,  loadingCustomerAdd,  loadingDashboard,  loadingStaffDetailsWeb,  successActivity,  successBookAppointment,  successBusiness, successBusinessAppointments, successBusinessCustomers, successBusinessDetails, successBusinessDocuments, successBusinessFields, successBusinessRestrict, successBusinessServices, successBusinessStaff, successBusinessTimings, successCustomerAdd, successCustomerDetails, successDashboard, successStaffDetailsWeb, loadingBusinessProducts, successBusinessProducts, failedBusinessProducts } from "./reducer";
import { errorMessage, successMessage } from "../error/action";
import { Debouncer } from "../../utils/debouncer";
import store from "../../store";
import axios from "axios";

export const getBusiness = async (dispatch) => {
try {
    console.log('here verify');
    dispatch(loadingBusiness());
    const data = await getData(BUSINESS);
    console.log('here here verify', data?.data);
    dispatch(successBusiness(data?.data));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');
    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusiness({ message: error.response?.data?.error?.message || error?.message }));
}
}
export const getBusinessDetails = async (dispatch,id) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessDetails());
    const data = await getData(BUSINESS_ID(id));
    console.log('here here verify', data?.data);
    dispatch(successBusinessDetails(data?.data?.business));
    dispatch(successBusinessServices(data?.data?.services));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessDetails({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const getBusinessProfile = async (dispatch) => {
try {
    console.log('here verify');
    // dispatch(loadingBusinessDetails());
    const data = await getData(BUSINESS_PROFILE);
    console.log('here here verify', data?.data);
    dispatch(successBusinessDetails(data?.data?.user));
    // dispatch(successBusinessServices(data?.data?.services));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessDetails({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const getBusinessAppointmentDetails = async (dispatch,id) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessAppointments());
    const data = await getDataSimple(APPOINTMENTS(id));
    // Server replies { data: [...], meta, labels }; pages read appointments[0]
    const inner = data?.data;
    const list = Array.isArray(inner) ? inner : (Array.isArray(inner?.data) ? inner.data : []);
    dispatch(successBusinessAppointments(list));
    // console.log('here here verify', data?.data);
    // dispatch(successBusinessDetails(data?.data?.business));
    // dispatch(successBusinessServices(data?.data?.services));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessAppointments({ message: error.response?.data?.error?.message || error?.message }));
}
}
export const getBusinessDetailsForPatients = async (dispatch,id) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessDetails());
    const data = await getDataSimple(BUSINESS_ID(id)+'/common');
    console.log('here here verify', data?.data);
    dispatch(successBusinessDetails(data?.data?.business));
    dispatch(successBusinessServices(data?.data?.services));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessDetails({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const getDetailsForPatients = async (dispatch,id) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessDetails());
    const data = await getDataSimple(PATIENT_ID(id)+'/common');
    console.log('here here verify', data);
    dispatch(successCustomerDetails(data?.data[0]));
    // dispatch(successBusinessServices(data?.data?.services));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    // dispatch(failedBusinessDetails({ message: error.response?.data?.error?.message || error?.message }));
}
}
// Keep getDetailsForCustomers for backward compatibility
export const getDetailsForCustomers = getDetailsForPatients;
export const getBusinessServices = async (dispatch,id) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessServices());
    const data = await getData(BUSINESS_ID(id)+'/services');
    console.log('here here verify services', data?.data);
    dispatch(successBusinessServices(data?.data));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessService({ message: error.response?.data?.error?.message || error?.message }));
}
}
export const deleteBusinessServices = async (dispatch,id) => {
try {
    console.log('here verify');
    // dispatch(loadingBusinessServices());
    await deleteData(DELETE_SERVICE(id));
    // console.log('here here verify services', data?.data);
    successMessage(dispatch,"Deleted Services successfully.")
    // dispatch(successBusinessServices(data?.data));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessService({ message: error.response?.data?.error?.message || error?.message }));
}
}
export const getBusinessAppointment = async (dispatch,id,date) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessAppointments());
    const data = await getData(BUSINESS_ID(id)+'/appointmets?date='+date);
    console.log('here here verify appointments', data.data);
    dispatch(successBusinessAppointments(data?.data));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify appointments');
    dispatch(failedBusinessAppointments({ message: error.response?.data?.error?.message || error?.message }));
}
}
export const deleteBusinessAppointment = async (dispatch,id) => {
try {
    // console.log('here verify');
    // const data = dispatch(loadingBusinessAppointments());
    const data = await deleteData(DELETE_APPOINTMENT(id));
    console.log('here here verify appointments', data.data);
    successMessage(dispatch,"Appointment deleted successfully.")
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify appointments');
    dispatch(failedBusinessAppointments({ message: error.response?.data?.error?.message || error?.message }));
}
}
export const cancelBusinessAppointment = async (dispatch,id) => {
    // console.log("Hi "+ req.customer_id + ",\nYour appointment is booked for " + req.start_date+ " at " + req.start_time + 
    // "\nWe look forward to serve you soon.\nThank You!\n\nTeam "+ req.staff_id +"Contact- "+ req.staff_id +"\ntheappointmentapp.com");

try {
    // console.log('here verify');
    // const data = dispatch(loadingBusinessAppointments());
    const data = await deleteData(CANCEL_APPOINTMENT(id));
    console.log('here here verify appointments', data.data);
    successMessage(dispatch,"Appointment cancelled successfully.")
    // const smsApiKey = 'C8JfihwMuczD3Thw';
    // const senderId = 'DGAPPT';
    // const recipientNumbers = '9082512330';//user's number

    //"Hi {#var#},
    // Your appointment is cancelled for {#var#}
    // We look forward to serve you soon.
    // Thank You!

    // Team {#var#}
    // Contact- {#var#}
    // theappointmentapp.com"

    // Hi ${details[0].full_name},\nYour appointment is cancelled for ${moment(data[0].start_date).format('DD-MM-yyyy')} at ${moment(data[0].start_time,"HH:mm:ss").format('hh:mm a')}\nWe look forward to serve you soon.\nThank You!\nTeam ${profile.rows[0].name}\nContact- ${profile.rows[0].contact}\ntheappointmentapp.com\nDIGITAL AMIGOS
    // Hi ${details[0].full_name},\nYour appointment is rescheduled on ${moment(start_date).format('DD-MM-yyyy')} at ${moment(start_time,"HH:mm:ss").format('hh:mm a')}\nThank You!\nTeam ${profile.rows[0].name}\nContact- ${profile.rows[0].contact}\ntheappointmentapp.com\nDIGITAL AMIGOS
    // Hi ${details[0].full_name},\nYour appointment is successfully. booked on ${moment(start_date).format('DD-MM-yyyy')} at ${moment(start_time,"HH:mm:ss").format('hh:mm a')}\nThank You!\n${profile.rows[0].name}\n${profile.rows[0].contact}\ntheappointmentapp.com\nDIGITAL AMIGOS

    // const message = "Hi "+ req.customer_id + ",\nYour appointment is cancelled for " + req.start_date+ " at " + req.start_time + "\nWe look forward to serve you soon.\nThank You!\n\nTeam "+ req.staff_id +"Contact- "+ req.staff_id +"\ntheappointmentapp.com";
    // console.log(message);
    // const smsApiUrl = `http://sms.osdigital.in/V2/http-api.php?apikey=${smsApiKey}&senderid=${senderId}&number=${recipientNumbers}&message=${message}&format=json`;
    // console.log("API went")
    // try {
    //     console.log("API went2")
    //     const smsApiResponse = await axios.post(smsApiUrl);
    //     console.log('SMS API Response:', smsApiResponse.data);
    //   } catch (smsApiError) {
    //     console.error('SMS API Error:', smsApiError);
    //   }
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify appointments');
    dispatch(failedBusinessAppointments({ message: error.response?.data?.error?.message || error?.message }));
}
}
export const rescheduleBusinessAppointment = async (dispatch,id,req) =>{
    console.log(id,req);
    
    try {
        console.log('hereherherher');
        // dispatch(loadingBusinessAppointments());
        // const data ={
        //     // id:id,
        //     req:req
        //     // req:{
        //     //     ...req,
        //     //     id:id
        //     // }

        // }
        await putData(RESCHEDULE_APPOINTMENT(id),req);
        // await getBusinessAppointmentDetails(dispatch,id)
        successMessage(dispatch,"Edited the appointment successfully.")
    // const smsApiKey = 'C8JfihwMuczD3Thw';
    // const senderId = 'DGAPPT';
    // const recipientNumbers = '9082512330';//user's number
    // "Hi {#var#},
    // Your appointment is rescheduled on {#var#}
    // Thank You!

    // Team {#var#}
    // Contact- {#var#}
    // theappointmentapp.com"

    // // Hi ${details[0].full_name},\nYour appointment is cancelled for ${moment(data[0].start_date).format('DD-MM-yyyy')} at ${moment(data[0].start_time,"HH:mm:ss").format('hh:mm a')}\nWe look forward to serve you soon.\nThank You!\nTeam ${profile.rows[0].name}\nContact- ${profile.rows[0].contact}\ntheappointmentapp.com\nDIGITAL AMIGOS
    // // Hi ${details[0].full_name},\nYour appointment is rescheduled on ${moment(start_date).format('DD-MM-yyyy')} at ${moment(start_time,"HH:mm:ss").format('hh:mm a')}\nThank You!\nTeam ${profile.rows[0].name}\nContact- ${profile.rows[0].contact}\ntheappointmentapp.com\nDIGITAL AMIGOS
    // // Hi ${details[0].full_name},\nYour appointment is successfully. booked on ${moment(start_date).format('DD-MM-yyyy')} at ${moment(start_time,"HH:mm:ss").format('hh:mm a')}\nThank You!\n${profile.rows[0].name}\n${profile.rows[0].contact}\ntheappointmentapp.com\nDIGITAL AMIGOS

    // const message = "Hi "+ req.customer_id + ",\nYour appointment is rescheduled on " + req.start_date+ " at " + req.start_time + "\nThank You!\n\nTeam "+ req.staff_id +"Contact- "+ req.staff_id +"\ntheappointmentapp.com\nDIGITAL AMIGOS";
    // console.log(message);
    // const smsApiUrl = `http://sms.osdigital.in/V2/http-api.php?apikey=${smsApiKey}&senderid=${senderId}&number=${recipientNumbers}&message=${message}&format=json`;
    // console.log("API went")
    // try {
    //     console.log("API went2")
    //     const smsApiResponse = await axios.post(smsApiUrl);
    //     console.log('SMS API Response:', smsApiResponse.data);
    //   } catch (smsApiError) {
    //     console.error('SMS API Error:', smsApiError);
    //   }
    }
    catch (error){
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');
    }
}

export const completeBusinessAppointment = async(dispatch,id,req) =>{
    try {
        await patchData(COMPLETE_APPOINTMENT(id),req);
        successMessage(dispatch,"Completed appointment")
    }
    catch (err){
        errorMessage(dispatch,'Error completing Appointment')
    }
}

export const updateAppointmentStatus = async(dispatch, id, status) => {
    try {
        await patchData(UPDATE_APPOINTMENT_STATUS(id), { status });
        successMessage(dispatch, `Appointment status updated to ${status}`);
    }
    catch (err){
        errorMessage(dispatch, err?.response?.data?.error?.message || 'Error updating appointment status');
    }
}
export const getBusinessDocuments = async (dispatch,id) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessDocuments());
    const data = await getData(BUSINESS_ID(id)+'/documents');
    console.log('here here verify', data?.data);
    dispatch(successBusinessDocuments(data?.data));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessDocuments({ message: error.response?.data?.error?.message || error?.message }));
}
}
export const getBusinessFields = async (dispatch, businessId = null) => {
try {
    dispatch(loadingBusinessFields());
    // Own business: every module's fields (the API defaults to customer fields only, for the mobile app)
    const endpoint = businessId ? `${BUSINESS_ID(businessId)}/fields` : `${BUSINESS_FIELDS}?module=all`;
    const data = await getData(endpoint);
    const fields = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
    dispatch(successBusinessFields(fields));
} catch (error) {
    console.log(error, 'log here verify');
    dispatch(failedBusinessFields({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const addBusinessFields = async (dispatch, fields, module = 'customers') => {
try {
    const selectorAuth = store.getState().auth;
    const businessId = selectorAuth?.user?.business_id;
    await postData(BUSINESS_FIELDS, { business_id: businessId, module, data: fields });
    successMessage(dispatch, 'Custom field(s) added successfully.');
    await getBusinessFields(dispatch);
} catch (error) {
    errorMessage(dispatch, error.response?.data?.error?.message || error?.response?.data?.message || 'Failed to add custom fields');
    throw error;
}
}

export const editBusinessFieldLabel = async (dispatch, fieldId, label) => {
try {
    await putData(BUSINESS_FIELD_ID(fieldId), { label });
    successMessage(dispatch, 'Custom field updated successfully.');
    await getBusinessFields(dispatch);
} catch (error) {
    errorMessage(dispatch, error.response?.data?.error?.message || error.response?.data?.error || 'Failed to update custom field');
    throw error;
}
}

export const deleteBusinessField = async (dispatch, fieldId) => {
try {
    await deleteData(BUSINESS_FIELD_ID(fieldId));
    successMessage(dispatch, 'Custom field deleted successfully.');
    await getBusinessFields(dispatch);
} catch (error) {
    errorMessage(dispatch, error.response?.data?.error?.message || 'Failed to delete custom field');
    throw error;
}
}

export const connectGoogleCalendar = async (dispatch, googleData) => {
try {
    await postData(GOOGLE_CALENDAR_CONNECT, {
        headers: JSON.stringify({ Authorization: `Bearer ${googleData.access_token}` }),
        access_token: googleData.access_token,
        google_id: googleData.google_id,
    });
    successMessage(dispatch, 'Google Calendar connected successfully.');
    await getBusinessProfile(dispatch);
} catch (error) {
    errorMessage(dispatch, error.response?.data?.error?.message || 'Failed to connect Google Calendar');
    throw error;
}
}

export const getBusinessStaffDetails = async (dispatch,id) => {
try {
    console.log('here verify');
    dispatch(loadingStaffDetailsWeb());
    const data = await getDataSimple(BUSINESS_STAFF_ID(id));
    console.log('here here verify', data?.data);
    dispatch(successStaffDetailsWeb(data?.data[0]));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedStaffDetailsWeb({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const getBusinessStaff = async (dispatch,id) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessStaff());
    const data = await getData(BUSINESS_ID(id)+'/staff');
    console.log('here here verify', data?.data);
    dispatch(successBusinessStaff(data?.data));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessStaff({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const addServiceDashboard = async (dispatch,req,business_id) => {
try {
    console.log('here verify');
    dispatch(loadingDashboard());
    
    const data = await postData(SERVICES,{
        business_id,
        data:req
    });

    await getBusinessDashboard(dispatch);
    await getActivityLogs(dispatch, business_id);
    successMessage(dispatch,'Services are added successfully.');
    
    // console.log('here here verify', data?.data);
    // dispatch(successDashboard(data?.data));
} catch (error) {
    await getBusinessDashboard(dispatch);
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    // dispatch(failedDashboard({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const addStaffDashboard = async (dispatch,req) => {
try {
    console.log('here verify');
    dispatch(loadingDashboard());
    const selectorAuth = store.getState().auth;
    
    const data = await postData(STAFF,req);

    await getBusinessDashboard(dispatch);
    await getActivityLogs(dispatch, selectorAuth?.user?.business_id);
    successMessage(dispatch,'Staff is added successfully.');
    // console.log('here here verify', data?.data);
    // dispatch(successDashboard(data?.data));
} catch (error) {
    // dispatch(failedDashboard({ message: error.response?.data?.error?.message || error?.message }));
    await getBusinessDashboard(dispatch);
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error(error.response?.data?.error?.message  || 'Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
}
}

export const completeProfileDashboard = async (dispatch,req) => {
try {
    console.log('here verify');
    dispatch(loadingDashboard());
    
    const data = await postData(REGISTER+'/web/complete',req);

    await getBusinessDashboard(dispatch);
    // console.log('here here verify', data?.data);
    // dispatch(successDashboard(data?.data));
} catch (error) {
    await getBusinessDashboard(dispatch);
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error(error.response?.data?.error?.message || 'Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    // dispatch(failedDashboard({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const completeProfileDashboardGoogle = async (dispatch,req) => {
try {
    console.log('here verify');
    dispatch(loadingDashboard());
    const data = await postData(REGISTER+'/complete-profile',req);
    await getBusinessDashboard(dispatch);
} catch (error) {
    await getBusinessDashboard(dispatch);
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error(error.response?.data?.error?.message || 'Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    // dispatch(failedDashboard({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const getBusinessDashboard = async (dispatch) => {
try {
    console.log('here verify');
    dispatch(loadingDashboard());
    const data = await getData(DASHBOARD+'?date='+new Date().getFullYear()+'-'+String(new Date().getMonth()+1).padStart(2,'0')+'-'+String(new Date().getDate()).padStart(2,'0'));
    console.log('here here verify', data?.data);
    dispatch(successDashboard(data?.data));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedDashboard({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const getBusinessStaffAll = async (dispatch,id,service_id) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessStaff());
    const data = await getDataSimple(STAFF_ID(id)+'?service='+service_id);
    console.log('here here verify', data?.data);
    dispatch(successBusinessStaff(data?.data));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessStaff({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const addBusinessStaff = async (dispatch,id,req) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessStaff());
    await postData(BUSINESS_ID(id)+'/staff',req);
    // console.log('here here verify', data?.data);
    // dispatch(successBusinessStaff(data?.data));
    await getBusinessStaff(dispatch,id);
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    // dispatch(failedBusinessStaff({ message: error.response?.data?.error?.message || error?.message }));
}
}
// export const editBusinessStaff = async (dispatch,id,req,staff_id) => {
// try {
//     console.log('here verify');
//     dispatch(loadingBusinessStaff());
//     await putData(BUSINESS_ID(id)+'/staff/'+staff_id,req);
//     // console.log('here here verify', data?.data);
//     // dispatch(successBusinessStaff(data?.data));
//     await getBusinessStaff(dispatch,id);
// } catch (error) {
//     errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

//     // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
//     console.log(error, 'log here verify');
//     // dispatch(failedBusinessStaff({ message: error.response?.data?.error?.message || error?.message }));
// }
// }
export const editBusinessStaff = async (dispatch,id,req) => {
    try {
        console.log('here verify');
        dispatch(loadingBusinessStaff());
        const data = {
            id:id,
            req:{
                ...req,
                id:id,
            }
        }
        console.log(data);
        await putData(STAFF,data.req);
        // console.log('here here verify', data?.data);
        // dispatch(successBusinessStaff(data?.data));
        await getBusinessStaff(dispatch,id);
        successMessage(dispatch,"Staff Details Edited successfully.");
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');
    
        // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
        console.log(error, 'log here verify');
        // dispatch(failedBusinessStaff({ message: error.response?.data?.error?.message || error?.message }));
    }
    }
export const editBusinessPatients = async (dispatch,patientId,req,businessId) => {
    try {
        console.log('here verify');
        dispatch(loadingBusinessCustomers());
        await putData(PATIENTS+'/'+patientId,req);
        // console.log('here here verify', data?.data);
        // dispatch(successBusinessStaff(data?.data));
        if(businessId) {
            await getBusinessPatients(dispatch,businessId);
        }
        successMessage(dispatch,'Patient details edited successfully.');
    } catch (error) {
        errorMessage(dispatch,error?.response?.data?.error?.message || 'Failed to edit patient. Please try again.');
        // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
        console.log(error, 'log here verify');
        // dispatch(failedBusinessStaff({ message: error.response?.data?.error?.message || error?.message }));
    }
    }
// Keep editBusinessCustomers for backward compatibility
export const editBusinessCustomers = editBusinessPatients;
    
export const deleteBusinessStaff = async (dispatch,staff_id) => {
    try {
    console.log(staff_id)
    // console.log('here verify',dispatch);
    // dispatch(loadingBusinessStaff());
    await deleteData(STAFF+'/'+staff_id);
    // await getBusinessStaff(dispatch,id);
    successMessage(dispatch,"Staff deleted successfully.")
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
}
}
export const addBusinessPatients = async (dispatch,id,req,nav) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessCustomers());
    const response = await postData(BUSINESS_ID(id)+'/patients',req);
    // console.log('here here verify', data?.data);
    // dispatch(successBusinessStaff(data?.data));
    await getBusinessPatients(dispatch,id);
    await getBusinessDashboard(dispatch);
    await getActivityLogs(dispatch, id);
    successMessage(dispatch,'Patient added successfully.');
    if(nav){
        nav();
    }
    return response; // Return response for success handling
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error(error.response?.data?.error?.message || 'Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessCustomers({ message: error.response?.data?.error?.message || 'Something went wrong' }));
    throw error; // Re-throw error so form knows submission failed
}
}
// Keep addBusinessCustomers for backward compatibility
export const addBusinessCustomers = addBusinessPatients;
// export const editBusinessCustomers = async (dispatch, id, values2) => {
//     console.log(id,values2)
//     try {
//     //   dispatch(loadingBusinessCustomers());
//       await putData(CUSTOMERS+'/'+ id, values2); 
//       await getBusinessCustomers(dispatch, id); 
//       successMessage(dispatch,"Customer Details Updated")
//     } catch (error) {
//       errorMessage(dispatch, error.response?.data?.error?.message || 'Server went down, please try again later');
//       console.log(error, 'Error while editing customer details');
//       // Optionally, dispatch a failure action here if needed
//     }
//   };
export const deletePatients = async (dispatch,id,staff_id) => {
    try {
        // console.log('here verify',dispatch);
        dispatch(loadingBusinessCustomers());
        await deleteData(PATIENTS+'/'+staff_id);
        await getBusinessPatients(dispatch,id);
        successMessage(dispatch,"Patient details deleted successfully.")
    } catch (error) {
        errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

        // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
        console.log(error, 'log here verify');
    }
}
// Keep deleteCustomers for backward compatibility
export const deleteCustomers = deletePatients;
// export const deleteCustomers = async (dispatch, id) => {
// try {
//     // Optional: Dispatch an action to indicate that loading has started
//     dispatch(loadingBusinessCustomers());

//     // Make the DELETE request to the API endpoint
//     const response = await deleteData(CUSTOMERS+'/'+`${id}`);

//     // Optional: Dispatch an action to update the customer list after successful deletion
//     // await getBusinessCustomers(dispatch, id);

//     // Optional: Handle success cases or display messages to the user

//     console.log('Customer deletion successful:', response.data);
// } catch (error) {
//     // Handle errors and display error messages to the user
//     console.log('Error deleting customer:', error.message);
// }
// };

const debouncer = new Debouncer(300);

export const getBusinessPatients = async (dispatch,id,query='') => {
// debouncer.debounce(async()=>{
    try {
        // console.log('here verify');
        dispatch(loadingBusinessCustomers());
        const data = await getData('/patient?patient='+query);
        // console.log('here here verify', data);
        // Ensure we always pass an array to the reducer
        const patientsData = data?.data;
        const patientsArray = Array.isArray(patientsData) ? patientsData : (patientsData?.data && Array.isArray(patientsData.data) ? patientsData.data : []);
        dispatch(successBusinessCustomers(patientsArray));
    } catch (error) {
        // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');
        
        // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
        console.log(error, 'log here verify');
        dispatch(failedBusinessCustomers({ message: error.response?.data?.error?.message || error?.message }));
    }
// })
}
// Keep getBusinessCustomers for backward compatibility
export const getBusinessCustomers = getBusinessPatients;

export const restrictBusiness = async (dispatch,id,restrict) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessRestrict());
    const data = await postData(BUSINESS_ID(id),{restrict});
    console.log('here here verify', data?.data);
    dispatch(successBusinessRestrict({id,restrict}));
    // await getBusiness(dispatch);
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessRestrict({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const renewBusiness = async (dispatch,id,plan,month,discount) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessRestrict());
    const data = await postData(BILLING+'/'+id,{plan,month,discount});
    console.log('here here verify', data?.data);
    dispatch(successBusinessRestrict());
    await getBusiness(dispatch);
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessRestrict({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const editBusiness = async (dispatch,id,dataP) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessRestrict());
    const data = await putData(BUSINESS_ID(id)+'/admin',dataP);
    console.log('here here verify', data?.data);
    dispatch(successBusinessRestrict());
    await getBusinessDetails(dispatch,id);
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessRestrict({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const editBusinessServices = async (dispatch,req) => {
    // const data = await postData(SERVICES,{
    //     business_id,
    //     data:req
    // });
    try {
        // const data = {
        //     id: id,
        //     data:[
        //         {
        //             label:dataP.service,
        //             value:dataP.charges,
        //         }
        //     ]
        // }
        const req2 = {
            id: req.id,
            data:
            [
                {
                    label:req.service,
                    value:req.charges,
                }
            ],
            custom_fields: req.custom_fields || {},
        }
        console.log(req2)
        console.log(req.business_id)
    console.log('here verify');
    // dispatch(loadingBusinessRestrict());
    // console.log(dataP);
    await putData(SERVICES,req2);
    // console.log('here here verify', data?.data);
    // dispatch(successBusinessRestrict());
    successMessage(dispatch,"Service Edited successfully..")
    await getBusinessServices(dispatch,req.business_id);
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessRestrict({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const addStaffTimings = async (dispatch,id,business_id,date,dataP,recurring) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessTimings());
    // console.log(dataP);
    await postData(TIMINGS(business_id,id,date),{timings:dataP,recurring});
    // console.log('here here verify', data?.data);
    // dispatch(successBusinessRestrict());
    // await getBusinessServices(dispatch,business_id);
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessTimings({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const addbusinessAppointment = async (dispatch,req2,req,nav) => {
    console.log('here verify21 ');
    console.log(req2.contact);
    // console.log("Hi "+ req.customer_id + ",\nYour appointment is booked for " + req.start_date+ " at " + req.start_time + 
    // "\nWe look forward to serve you soon.\nThank You!\n\nTeam "+ req.staff_id +"\nContact- "+ req.staff_id +"\ntheappointmentapp.com");
    // Hi ${details[0].full_name},\nYour appointment is cancelled for ${moment(data[0].start_date).format('DD-MM-yyyy')} at ${moment(data[0].start_time,"HH:mm:ss").format('hh:mm a')}\nWe look forward to serve you soon.\nThank You!\nTeam ${profile.rows[0].name}\nContact- ${profile.rows[0].contact}\ntheappointmentapp.com
try {
    // toast.error('Something went wrong 2',{position:toast.POSITION.TOP_RIGHT});

    const selectorAuth = store.getState().auth;
    dispatch(loadingBookAppointment());
    // console.log(dataP);
    await postData(APPOINTMENT,req);
    await getBusinessDashboard(dispatch);
    await getActivityLogs(dispatch, selectorAuth?.user?.business_id);
    
    successMessage(dispatch,'Appointment is booked successfully.');
    // SENDGRID_API_KEY=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
    // SMS_URL=http://sms.osdigital.in/V2/http-api.php
    // SMS_HOST=sms.osdigital.in
    // SMS_PATH=/V2/http-api.php
    // SMS_API_KEY=C8JfihwMuczD3Thw
    // SMS_SENDER=DGAPPT
    // const smsApiKey = 'C8JfihwMuczD3Thw';
    // const senderId = 'DGAPPT';
    // const recipientNumbers ="+91 "+req2.contact;//user's number
//     "Hi {#var#},
    // Your appointment is successfully. booked on {#var#}
    // Thank You!

    // Team {#var#}
    // Contact- {#var#}
    // theappointmentapp.com"

    // // Hi ${details[0].full_name},\nYour appointment is cancelled for ${moment(data[0].start_date).format('DD-MM-yyyy')} at ${moment(data[0].start_time,"HH:mm:ss").format('hh:mm a')}\nWe look forward to serve you soon.\nThank You!\nTeam ${profile.rows[0].name}\nContact- ${profile.rows[0].contact}\ntheappointmentapp.com\nDIGITAL AMIGOS
    // // Hi ${details[0].full_name},\nYour appointment is rescheduled on ${moment(start_date).format('DD-MM-yyyy')} at ${moment(start_time,"HH:mm:ss").format('hh:mm a')}\nThank You!\nTeam ${profile.rows[0].name}\nContact- ${profile.rows[0].contact}\ntheappointmentapp.com\nDIGITAL AMIGOS
    // // Hi ${details[0].full_name},\nYour appointment is successfully. booked on ${moment(start_date).format('DD-MM-yyyy')} at ${moment(start_time,"HH:mm:ss").format('hh:mm a')}\nThank You!\n${profile.rows[0].name}\n${profile.rows[0].contact}\ntheappointmentapp.com\nDIGITAL AMIGOS

    // const message = "Hi "+ req2.customer_name + ",\nYour appointment is successfully booked on " + req.start_date+ " at " + req.start_time + "\nWe look forward to serve you soon.\nThank You!\n\nTeam- "+ req2.name +"\nContact- "+ req2.businessContact +"\ntheappointmentapp.com";
    // console.log(message);
    // const smsApiUrl = `http://sms.osdigital.in/V2/http-api.php?apikey=${smsApiKey}&senderid=${senderId}&number=${recipientNumbers}&message=${message}&format=json`;
    // console.log("API went")
    // try {
    //     console.log("API went2")
    //     const smsApiResponse = await axios.post(smsApiUrl);
    //     console.log('SMS API Response:', smsApiResponse.data);
    //   } catch (smsApiError) {
    //     console.error('SMS API Error:', smsApiError);
    //   }



    if(nav){
        nav();
    }
    // console.log('here here verify', data?.data);
    // dispatch(successBusinessRestrict());
    // await getBusinessServices(dispatch,business_id);
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error(error.response?.data?.error?.message || 'Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBookAppointment({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const registerPatient = async (dispatch,business_id,data,nav, socket, staff, route) => {
try {
    console.log('here verify');
    dispatch(loadingCustomerAdd());
    // console.log(dataP);
    const dat = await postDataSimple(PATIENT_ID(business_id)+'/all?type=patient',data);
    console.log(dat?.data[0].patient_id);
    socket.timeout(5000).emit('added_patient', dat?.data, () => {
        console.log('sent');
    });
    nav(staff?`/admin/business/${route}/${staff}/book-appointment/${dat?.data[0].patient_id}`:`/admin/business/${route}/book-appointment/${dat?.data[0].patient_id}`);
    dispatch(successCustomerAdd());
    return dat;
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedCustomerAdd({ message: error.response?.data?.error?.message || error?.message }));
}
}
// Keep registerCustomer and getBusinessDetailsForCustomers for backward compatibility
export const registerCustomer = registerPatient;
export const getBusinessDetailsForCustomers = getBusinessDetailsForPatients;
export const getStaffTimings = async (dispatch,id,business_id,date,) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessTimings());
    // console.log(dataP);
    const data = await getDataSimple(TIMINGS(business_id,id,date)+'&fromcus=true');
    console.log('here here verify', data?.data);
    dispatch(successBusinessTimings({timings:data?.data?.map(e=>e.start_time),timingsFull:data?.data}));
    // await getBusinessServices(dispatch,business_id);
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error(error.response?.data?.error?.message || error?.message ,{position:toast.POSITION.TOP_RIGHT});
    // console.log(error, 'log here verify');
    dispatch(failedBusinessTimings({ message: error.response?.data?.error?.message || error?.message }));
}
}

export const addAppointment = async(dispatch,business_id,customer_id,req,nav,staff_name,doc_data, setError,nameArr,socket,fcm, route)=>{
    try {
    const dt = {
        service_id:req.service.toString(),
        customer_id,
        staff_id:req.staff,
        start_date:req.date,
        end_date:req.date,
        start_time:req.start_time,
        end_time:req.end_time,
        reason:''
    }
    setError('');
    dispatch(loadingBookAppointment());
    var data = await postDataSimple(APPOINTMENTS(business_id)+'?type=customer',dt);
    if(doc_data && doc_data.length > 0){

        const formData = new FormData();
        formData.append('appointment_id',parseInt(data.data[0]?.appointment_id));
        formData.append('customer_id',parseInt(customer_id));
        formData.append('name',nameArr.join(','));
        // formData.append('customer_id',params.customerId);
        for (const iterator of doc_data) {
            formData.append(`img`, iterator, iterator.name);
        }
        formData.append(`decodedBusinessId`, parseInt(business_id));
        await postDataSimple(UPLOAD_DATA,formData);
        // toast.success('Appointment is booked successfully.',{position:toast.POSITION.TOP_RIGHT});
    }
    console.log(data?.data[0],'added app notification');

    const startMunites = parseInt(req.start_time.split(':')[0])*60+parseInt(req.start_time.split(':')[1]);
    const endMunites = parseInt(req.end_time.split(':')[0])*60+parseInt(req.end_time.split(':')[1]);
    if(data?.data[0].approved === 0){
        // alert(data?.data[0].approved.toString());
        
        await sendBookMessage(fcm,staff_name,`${data?.data[0].full_name} has requested to book an appointment with ${data?.data[0].staff_name} on ${moment(req.date).format('DD-MM-yyyy')} at ${moment(req.start_time,"HH:mm:ss").format('hh:mm a')} for ${endMunites - startMunites} mins.`,data?.data[0].approved === 1?'Appointment':'Notification');
        socket.timeout(5000).emit('book_appointment', data?.data, () => {
            console.log('sent red dot',data?.data);
        });
    }else{
        await sendBookMessage(fcm,staff_name,`${data?.data[0].full_name} has booked an appointment with ${data?.data[0].staff_name} on ${moment(req.date).format('DD-MM-yyyy')} at ${moment(req.start_time,"HH:mm:ss").format('hh:mm a')} for ${endMunites - startMunites} mins.`,data?.data[0].approved === 1?'Appointment':'Notification');
    }
    nav(`/admin/business/${route}/book-appointment/${customer_id}/status/${data.data[0]?.appointment_id}`);
    // toast.success('Appointment is booked',{position:toast.POSITION.TOP_RIGHT});
    dispatch(successBookAppointment());
} catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    console.log(error);
    setError((error.response?.data?.error?.message || error?.message) || 'Something went wrong');
    // toast.error('Appointment is not booked',{position:toast.POSITION.TOP_RIGHT});
    dispatch(failedBookAppointment());
}
}

export const getBusinessDocumentsOfPatient = async (dispatch,id) => {
try {
    console.log('here verify');
    dispatch(loadingBusinessDocuments());
    const data = await getDataSimple(APPOINTMENTS(id)+'/documents');
    // console.log('here here verify', data?.data);
    dispatch(successBusinessDocuments(data?.data));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
    console.log(error, 'log here verify');
    dispatch(failedBusinessDocuments({ message: error.response?.data?.error?.message || error?.message }));
}
}
// Keep getBusinessDocumentsOfCustomer for backward compatibility (must be after function definition)
export const getBusinessDocumentsOfCustomer = getBusinessDocumentsOfPatient;

export const  getActivityLogs = async (dispatch,id)=>{
try {
    dispatch(loadingActivity());
    const data = await getData(ACTIVITY(id));
    dispatch(successActivity(data?.data));
} catch (error) {
    // errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // console.log(error, 'log here verify');
    dispatch(errorActivity(error.response?.data?.error?.message || error?.message))
}
}
// export const patchBusinesslogo = async (dispatch,id,logo) => {
//     try {
//         console.log('here verify');
//         // dispatch(loadingBusinessRestrict());
//         const data = await patchData(BUSINESS_LOGO,{id,});
//         console.log('here here verify', data?.data);
//         dispatch(successBusinessRestrict());
//         await getBusinessServices(dispatch,business_id);
//     } catch (error) {
//         errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

//         // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
//         console.log(error, 'log here verify');
//         dispatch(failedBusinessRestrict({ message: error.response?.data?.error?.message || error?.message }));
//     }
// }

export const patchBusinessLogo = async (dispatch,id,logo) => {
console.log(id);
console.log(logo);
try {
    // dispatch(loadingBusinessDetails());
        // Server route: PATCH /business/:id/uploadLogo, multipart field "img"
        const form = new FormData();
        form.append('img', logo);
        await patchData(BUSINESS_ID(id) + '/uploadLogo', form);
        // console.log('here here verify', data?.data);
        // dispatch(successBusinessStaff(data?.data));
        await getBusinessDetails(dispatch,id);
        successMessage(dispatch,'Customer details edited successfully.');
    } catch (error) {
            errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

            // toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
            console.log(error, 'log here verify');
            // dispatch(failedBusinessStaff({ message: error.response?.data?.error?.message || error?.message }));
        }
        
    }


    // export const deleteAppointment = async (dispatch, id) => {
    //     try {
    //         // dispatch(loadingBusinessCustomers());
    //         await deleteData(`/appointment/${id}`);
    //         console.log(id);
    //         // You can call additional actions or functions if needed after the successful delete
    //         // For example, you might want to fetch updated appointment data
    //         await getBusinessAppointmentDetails(dispatch,id); 
    //         successMessage(dispatch, "Appointment deleted successfully.");
    //     } catch (error) {
    //         errorMessage(
    //         dispatch,
    //         error.response?.data?.error?.message || "Server went down. Please try again later"
    //         );
    //         console.log(error, "log here verify");
    //     }
    //     };
// const uploadData = async() => {
//     try {
//         // setloading(true);
//         // console.log(params.customerId);
//         const formData = new FormData();
//         formData.append('appointment_id',parseInt(params.appointmentId));
//         formData.append('customer_id',parseInt(params.customerId));
//         formData.append('name',selector?.appointments[0]?.staff_name+'-'+params.appointmentId+'-'+params.customerId);
//         // formData.append('customer_id',params.customerId);
//         for (const iterator of dragFile) {
//             formData.append(`img`, iterator, iterator.name);
//         }
//         formData.append(`decodedBusinessId`, parseInt(params.id));
//         await postDataSimple(UPLOAD_DATA,formData);
//         toast.success('Uploading successfull',{position:toast.POSITION.TOP_RIGHT});
//         setloading(false);
//         setDragFile([]);
//     } catch (error) {
//         console.log(error);
//         toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
//         setloading(false);
//     }
//   }

// Product Actions
export const getBusinessProducts = async (dispatch, businessId) => {
  try {
    dispatch(loadingBusinessProducts());
    const data = await getData(PRODUCTS);
    if (data?.success && data?.data) {
      dispatch(successBusinessProducts(data.data));
    } else if (Array.isArray(data)) {
      dispatch(successBusinessProducts(data));
    } else {
      dispatch(successBusinessProducts([]));
    }
  } catch (error) {
    console.log(error, 'Error getting products');
    dispatch(failedBusinessProducts({ message: error.response?.data?.error?.message || error?.message }));
    errorMessage(dispatch, error.response?.data?.error?.message || 'Server went down please try again later');
  }
};

export const addBusinessProduct = async (dispatch, businessId, req) => {
  try {
    dispatch(loadingBusinessProducts());
    await postData(PRODUCTS, req);
    await getBusinessProducts(dispatch, businessId);
    successMessage(dispatch, 'Product added successfully.');
    return true;
  } catch (error) {
    errorMessage(dispatch, error.response?.data?.error?.message || 'Server went down please try again later');
    throw error;
  }
};

export const editBusinessProduct = async (dispatch, id, req, businessId) => {
  try {
    dispatch(loadingBusinessProducts());
    await putData(PRODUCT_ID(id), req);
    await getBusinessProducts(dispatch, businessId);
    successMessage(dispatch, 'Product details edited successfully.');
  } catch (error) {
    errorMessage(dispatch, error.response?.data?.error?.message || 'Server went down please try again later');
    throw error;
  }
};

export const deleteBusinessProduct = async (dispatch, id, businessId) => {
  try {
    dispatch(loadingBusinessProducts());
    await deleteData(PRODUCT_ID(id));
    await getBusinessProducts(dispatch, businessId);
    successMessage(dispatch, 'Product deleted successfully.');
  } catch (error) {
    errorMessage(dispatch, error.response?.data?.error?.message || 'Server went down please try again later');
  }
};